import React from "react";
import { ColumnSettings } from "@design-system/ViewToolbar/ColumnSettings";
import { MatchItemType } from "./types";
import { useAccrualMatchView } from "./useAccrualMatchView";
import { useAccrualMatchViewDefaults } from "./useAccrualMatchViewDefaults";

interface Props {
    /** Must match the `columnsVariant` passed to the enclosing AccrualMatchViewProvider. */
    columnsVariant?: "workspaceMatched" | "legacy";
    /** Invoices and bills rename the ledger columns to their account titles. */
    matchItemType?: MatchItemType | null;
}

export const AccrualMatchColumnSettings: React.FC<Props> = ({
    columnsVariant = "legacy",
    matchItemType = null,
}) => {
    const { tableView, setTableView } = useAccrualMatchView();
    // Shared with AccrualMatchViewProvider so the Reset target and the
    // "changed from default" indicator (PRO-12048) always match the actual
    // table default and its reconciliation config. `matchItemType` only
    // changes column titles, not which columns exist.
    const { defaultView, viewConfig } = useAccrualMatchViewDefaults(
        columnsVariant,
        matchItemType,
    );

    return (
        <ColumnSettings
            view={tableView}
            viewConfig={viewConfig}
            defaultView={defaultView}
            onViewChange={setTableView}
        />
    );
};
